var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogomark = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logomark_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#logomark_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.233 1.073h33.509l-5.575 8.946H.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.56 12.141 2.62 24.505h18.706l3.638-6.82H13.818l2.428-5.544z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.178 26.577 2.62 39.089l11.36-12.512z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logomark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logomark_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .75h40v38.5H0z"
  })))));
};
export default SvgLogomark;